import type { ReactNode } from "react"
import { ScratchTicket } from "./ScratchTicket"

type PrizeScratchCardProps = {
  playable: boolean
  revealed: boolean
  autoScratch?: boolean
  logoUrl?: string
  storeName: string
  onScratchStart: () => void
  onLockedTouch?: () => void
  onUncovered: () => void
  children: ReactNode
}

/** The scratch card as a lottery ticket in the fixed game palette (only the small store logo in its header); `autoScratch` scrapes it in a short zigzag; the foil only hides what the server drew. */
export function PrizeScratchCard({ playable, revealed, autoScratch = false, logoUrl, storeName, onScratchStart, onLockedTouch, onUncovered, children }: PrizeScratchCardProps) {
  return (
    <ScratchTicket
      logoUrl={logoUrl}
      storeName={storeName}
      playable={playable}
      revealed={revealed}
      autoScratch={autoScratch}
      onScratchStart={onScratchStart}
      onLockedTouch={onLockedTouch}
      onUncovered={onUncovered}
    >
      {children}
    </ScratchTicket>
  )
}
